// extracted by mini-css-extract-plugin
module.exports = {"heading":"oM3la"};